/* import __COLOCATED_TEMPLATE__ from './edit-legals.hbs'; */
import Component from '@glimmer/component';
import { dropTask } from 'ember-concurrency';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { handleErrorResponseWithModal, handleFormErrorOrModal } from 'sh-www/utils/handles-errors';
import { showModal } from "sh-www/utils/modal-controls";

const CLASS_NAME = 'SH-c-edit-legals';

const HTML_PREVIEW_FORM_INPUTS = [
  'title',
  'content',
];

export default class EditLegals extends Component {
  @service('state-managers/application') applicationStateManager;
  @service('commands/company-commands') companyCommandService;

  @service api;
  @service shData;

  @tracked companyLegals = [];
  @tracked errors = {};
  @tracked isDocumentEditorOpen = false;

  get className() {
    return CLASS_NAME;
  }

  constructor() {
    super(...arguments);

    this.loadLegalsTask.perform(this.args.company.id);
  }

  @action
  onSaveClicked(title, content) {
    if (this.validateForm(title, content)) {
      return;
    }

    const company = this.args.company;
    const modalModel = {
      titleText: 'Are you sure you want to save this document?',
      bodyText: `Are you sure you want to save "${title}"?`,
      actionButtonText: 'Save',
      cancelButtonText: 'Cancel',
      width: 'medium',
      confirmAction: () => {
        this.saveLegalTask.perform(company.id, title, content);
      },
    };

    showModal(this, 'confirmation', modalModel);
  }

  @action
  toggleAddDocument(isOpen) {
    this.errors = {};
    this.isDocumentEditorOpen = isOpen;
  }

  validateForm(title, content) {
    const errors = {};

    if (!title) {
      errors.title = 'Document title must not be empty.'
    }

    if (!content) {
      errors.content = 'Document body content must not be empty.'
    }

    this.errors = errors;

    return Boolean(Object.keys(this.errors).length);
  }

  @dropTask *loadLegalsTask(companyId) {
    try {
      const company = yield this.companyCommandService.loadCompany(
        companyId,
        [
          'legals',
        ]
      );
      const legals = company?.legals.slice() ?? [];

      legals.sort((legalA, legalB) => {
        if (legalA.isDefault) {
          return -1;
        }

        if (legalB.isDefault) {
          return 1;
        }

        return new Date(legalA.createdAt) > new Date(legalB.createdAt) ? -1 : 1;
      });

      this.companyLegals = legals;
    } catch (error) {
      handleErrorResponseWithModal(this, error, "There was a problem loading company legals. Please try again or contact support.");
    }
  }

  @dropTask *makeDefaultLegalTask(companyId, legalId) {
    try {
      yield this.companyCommandService.setDefaultLegal(legalId);
      yield this.loadLegalsTask.perform(companyId);
    } catch (error) {
      handleErrorResponseWithModal(this, error, "There was a problem making legal default");
    }
  }

  @dropTask *saveLegalTask(companyId, title, content) {
    try {
      yield this.companyCommandService.createLegal(companyId, title, content);
      this.isDocumentEditorOpen = false;
      yield this.loadLegalsTask.perform(companyId);
    } catch (error) {
      handleFormErrorOrModal(
        this,
        error,
        HTML_PREVIEW_FORM_INPUTS,
        false,
        'There was a problem saving new legal'
      );
    }
  }
}
